export enum RuleFormValidator {
    required = 'required',
    sizeCharacter = 'sizeCharacter',
    specialCharacter = 'specialCharacter',
    isNumber = 'isNumber',
    isLetter = 'isLetter',
    dateValidator = 'dateValidator',
    ageValidator = 'ageValidator',
    phoneValidator = 'phoneValidator',
}
